import React, {FC} from 'react';
import styles from './confirm-territory-phase-modal.module.scss'
import rejectIcon from "../../../../images/error-120.svg";
import Button from "../../../ui-kit/button/button";
import Modal from "../../../../shared/modal/modal";

interface ConfirmTerritoryPhaseModalProps {
    onClose: () => void;
}

const ConfirmTerritoryPhaseModal: FC<ConfirmTerritoryPhaseModalProps> = ({ onClose }) => {
    return (
        <Modal closeOnOverlayClick={false} onClose={onClose}>
            <div className={styles.verifiedConfirmTerritoryModal}>
                <h1 className={styles.title}>Creation of New Study</h1>
                <img className={styles.image} src={rejectIcon} alt='reject'/>
                <span className={styles.text}>The phase 1 boundaries DO NOT match with QC Criteria</span>
                <p className={styles.description}>Please correct data or reset changes</p>
                <Button
                    type='primary'
                    onClick={onClose}
                    className={styles.btn}
                >
                    Back to Phase Editing
                </Button>
            </div>
        </Modal>
    );
};

export default ConfirmTerritoryPhaseModal;